import { supabase } from '../lib/supabase';

export interface Notificacao {
  id: string;
  titulo: string;
  mensagem: string;
  tipo: 'info' | 'sucesso' | 'aviso' | 'erro';
  link: string | null;
  lida: boolean;
  criado_em: string;
}

export const notificacoesService = {
  async listar(cidadaoId: string, limit = 100): Promise<Notificacao[]> {
    const { data, error } = await supabase
      .from('notificacoes')
      .select('id, titulo, mensagem, tipo, link, lida, criado_em')
      .eq('cidadao_id', cidadaoId)
      .order('criado_em', { ascending: false })
      .limit(limit);
    if (error) throw error;
    return (data ?? []) as Notificacao[];
  },

  async contarNaoLidas(cidadaoId: string): Promise<number> {
    const { count } = await supabase
      .from('notificacoes')
      .select('*', { count: 'exact', head: true })
      .eq('cidadao_id', cidadaoId)
      .eq('lida', false);
    return count ?? 0;
  },

  async marcarComoLida(id: string): Promise<void> {
    await supabase.from('notificacoes').update({ lida: true, lida_em: new Date().toISOString() }).eq('id', id);
  },

  async marcarTodasComoLidas(cidadaoId: string): Promise<void> {
    await supabase
      .from('notificacoes')
      .update({ lida: true, lida_em: new Date().toISOString() })
      .eq('cidadao_id', cidadaoId)
      .eq('lida', false);
  },
};
